import { z } from 'zod';


// Validación del formulario "Editar: Corte" (pestañas General + Agrupación, submit único).
// La empresa NO es editable, por lo que no participa en la validación. Las reglas de período
// y agrupaciones son las mismas que en la creación; se reutilizan sus claves i18n.
const editMonthlyCutBaseSchema = z.object({
  id: z.number().int().positive(),
  year: z.union([
    z.coerce.number({ invalid_type_error: 'common:validation.invalidValue' }).int().positive(),
    z.null(),
  ]),
  month: z.union([
    z.coerce.number({ invalid_type_error: 'common:validation.invalidValue' }).int().positive(),
    z.null(),
  ]),
  startDate: z.string().min(1, 'attendance:monthlyCutCreate.validation.startDateRequired'),
  endDate: z.string().min(1, 'attendance:monthlyCutCreate.validation.endDateRequired'),
  // Agrupación: al menos una agrupación asignada (misma regla que en la creación).
  groupIds: z.array(z.number()).min(1, 'attendance:monthlyCutCreate.validation.groupsRequired'),
});

export const editMonthlyCutSchema = editMonthlyCutBaseSchema
  .refine((data) => data.year !== null, {
    message: 'attendance:monthlyCutCreate.validation.yearRequired',
    path: ['year'],
  })
  .refine((data) => data.month !== null, {
    message: 'attendance:monthlyCutCreate.validation.monthRequired',
    path: ['month'],
  })
  .refine(
    (data) => !data.startDate || !data.endDate || data.startDate <= data.endDate,
    {
      message: 'attendance:monthlyCutCreate.validation.dateRangeInvalid',
      path: ['endDate'],
    },
  );

export type EditMonthlyCutFormData = z.infer<typeof editMonthlyCutSchema>;
